import { createReducer, createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    setConfiguration: ['configuration']
})

export const ConfigurationTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
    configuration: null
}

/* ------------- Reducers ------------- */
export const configSetConfiguration = (state, { configuration }) => {
    return Object.assign({}, state, { configuration });
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.SET_CONFIGURATION]: configSetConfiguration
})